module.exports = __webpack_public_path__ + "media/packs/images/flags/JM-b990998d1cc7c66ab1eda6b4580df7b6.png";